import React, { useEffect } from "react";

const NeetoCalEmbed = () => {
  useEffect(() => {
    // Cargar el script de NeetoCal
    const script = document.createElement("script");
    script.src = "https://dreamcodesoft.neetocal.com/javascript/embed.js";
    script.async = true;

    // Agregar el script al documento
    document.body.appendChild(script);

    // Ejecutar el embed después de que el script esté listo
    script.onload = () => {
      if (window.neetoCal) {
        window.neetoCal.embed({
          type: "inline",
          id: "30b41c15-ba54-4a38-aa32-3960ebe73330",
          organization: "dreamcodesoft",
          elementSelector: "#inline-embed-container",
          styles: { height: "100%", width: "100%"},
        });
      }
    };

    // Limpiar el script al desmontar el componente
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div
      id="inline-embed-container"
      style={{ height: "900px", width: "100%" }}
    ></div>
  );
};

export default NeetoCalEmbed;
